<template>
  <div>
    <Layout/>
    <h4>Personas</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPersona" class="form-label">IdPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPersona" name="idPersona" v-model="datoPersona.idPersona" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoPersona.idEmpresa" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoPersona.idTipoIden">
                      <option v-for="tipoIden in tipoIdens" :value="tipoIden.idTipoIden" :key="tipoIden.idTipoIden">
                        {{ tipoIden.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idLocalidad" class="form-label"> Localidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoPersona.idLocalidad">
                      <option v-for="localidad in localidads" :value="localidad.idLocalidad" :key="localidad.idLocalidad">
                        {{ localidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEstadoCivil" class="form-label"> Estado Civil</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEstadoCivil" name="idEstadoCivil" v-model="datoPersona.idEstadoCivil">
                      <option v-for="estadoCivil in estadoCivils" :value="estadoCivil.idEstadoCivil" :key="estadoCivil.idEstadoCivil">
                        {{ estadoCivil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoPersona.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerNombre" class="form-label">PrimerNombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="primerNombre" name="primerNombre" v-model="datoPersona.primerNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="segundoNombre" class="form-label">SegundoNombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="segundoNombre" name="segundoNombre" v-model="datoPersona.segundoNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerApellido" class="form-label">PrimerApellido</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="primerApellido" name="primerApellido" v-model="datoPersona.primerApellido" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="segundoApellido" class="form-label">SegundoApellido</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="segundoApellido" name="segundoApellido" v-model="datoPersona.segundoApellido" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaNac" class="form-label">FechaNac</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaNac" name="fechaNac" v-model="datoPersona.fechaNac" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="direccion" name="direccion" v-model="datoPersona.direccion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="telefono" class="form-label">Telefono</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="telefono" name="telefono" v-model="datoPersona.telefono" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipoPersona" class="form-label">TipoPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipoPersona" name="tipoPersona" v-model="datoPersona.tipoPersona" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="sexo" class="form-label">Sexo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="sexo" name="sexo" v-model="datoPersona.sexo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="email" class="form-label">Email</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="email" name="email" v-model="datoPersona.email" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPersona.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarPersona" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPersona" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdBitacora</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdMedioCom</th>
          <th scope="col">Texto</th>
          <th scope="col">Estado</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">Medio de Comunicación</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="bitacora in datosPaginados" :key="bitacora.idBitacora">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(bitacora.idBitacora)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(bitacora.idBitacora)" title="Editar">edit_square</i></td>
          <td>{{bitacora.idBitacora}}</td>
          <td>{{bitacora.idPersona}}</td>
          <td>{{bitacora.idMedioCom}}</td>
          <td>{{bitacora.texto}}</td>
          <td>{{bitacora.estado}}</td>
          <td>{{getFormattedDate(bitacora.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{bitacora.medioComNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePersona(bitacora.idBitacora)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idBitacora" class="form-label">IdBitacora</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idBitacora" name="idBitacora" v-model="datoBitacora.idBitacora" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPersona" class="form-label">IdPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPersona" name="idPersona" v-model="datoBitacora.idPersona" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioCom" class="form-label"> Medio Com</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoBitacora.idMedioCom">
                      <option v-for="medioCom in medioComs" :value="medioCom.idMedioCom" :key="medioCom.idMedioCom">
                        {{ medioCom.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="texto" class="form-label">Texto</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="texto" name="texto" v-model="datoBitacora.texto" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarBitacora" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditBitacora" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      personas : [],
      datoPersona : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPersona: '',
      tipoIdens : [],
      localidads : [],
      estadoCivils : [],
// Variables master
// Variables details
      bitacoras : [],
      datoBitacora : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      medioComs : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idPersona = this.$route.params.p_idpersona
    this.abrirEditar(this.p_idPersona)
    this.getDataPagina(this.paginaActual)
    this.fetchTipoIdens()
    this.fetchLocalidads()
    this.fetchEstadoCivils()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idTipoIden'
        ,'idLocalidad'
        ,'idEstadoCivil'
        ,'documento'
        ,'primerNombre'
        ,'segundoNombre'
        ,'primerApellido'
        ,'segundoApellido'
        ,'fechaNac'
        ,'direccion'
        ,'telefono'
        ,'tipoPersona'
        ,'sexo'
        ,'email'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idTipoIden'
        ,'idLocalidad'
        ,'idEstadoCivil'
        ,'documento'
        ,'primerNombre'
        ,'segundoNombre'
        ,'primerApellido'
        ,'segundoApellido'
        ,'fechaNac'
        ,'direccion'
        ,'telefono'
        ,'tipoPersona'
        ,'sexo'
        ,'email'
      ];
      return validarForm(this.datoPersona, requiredFields, requiredFieldsText);
    },
    async guardarPersona(){
      if(this.validarForm() === 1){
        try {
          this.datoPersona.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/personas', this.datoPersona)
          swal("Correcto!", "Persona creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPersona(){
      if(this.validarForm() === 1){
        try {
          await api.post('/personas', this.datoPersona)
          swal("Correcto!", "Persona creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPersona={}
      this.titulo   = 'Crear Personas'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPersona){
      this.modalWindow = true
      if(idPersona != null){    
           api.get('/vwpersonas/'+idPersona).then(resp=>{
          this.datoPersona = resp.data;
           });
      }
      this.titulo   = 'Editar Personas'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPersona(){
      this.$router.push('/Persona')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.bitacoras.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwbitacoras/nombre/'+this.nombreBusqueda).then(response=>{
          this.bitacoras=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.bitacoras.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwbitacoras').then(response=>{
      this.bitacoras=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.bitacoras.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idTipoIden'
        ,'idLocalidad'
        ,'idEstadoCivil'
        ,'documento'
        ,'primerNombre'
        ,'segundoNombre'
        ,'primerApellido'
        ,'segundoApellido'
        ,'fechaNac'
        ,'direccion'
        ,'telefono'
        ,'tipoPersona'
        ,'sexo'
        ,'email'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idTipoIden'
        ,'idLocalidad'
        ,'idEstadoCivil'
        ,'documento'
        ,'primerNombre'
        ,'segundoNombre'
        ,'primerApellido'
        ,'segundoApellido'
        ,'fechaNac'
        ,'direccion'
        ,'telefono'
        ,'tipoPersona'
        ,'sexo'
        ,'email'
      ];
      return validarForm(this.datoPersona, requiredFields, requiredFieldsText);
    },
    async guardarBitacora(){
      if(this.validarForm() === 1){
        try {
          this.datoBitacora.idPersona = this.datoPersona.idPersona;
          await api.post('/bitacoras', this.datoBitacora)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Bitacora creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditBitacora(){
      if(this.validarForm() === 1){
        try {
          await api.post('/bitacoras', this.datoBitacora)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Bitacora creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoBitacora={}
      this.titulo   = 'Crear Personas'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idBitacora){
      this.modalWindow = true
      if(idBitacora != null){    
           api.get('/vwbitacoras/'+idBitacora).then(resp=>{
          this.datoBitacora = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Personas'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idBitacora){
      this.modalWindow = true
      if(idBitacora != null){
        this.$router.push('/bitacoramd/'+idBitacora)
      }
    },
    async deleteBitacora (idBitacora) {
      try{
        await api.delete('/bitacoras/'+idBitacora)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchTipoIdens() {
      fetch('http://localhost:8080/api/v1/tipoidens')
        .then(response => response.json())
        .then(data => {
          this.tipoIdens = data;
        })
        .catch(error => {
          console.error('Error fetching tipoIdens:', error);
        });
    },
    fetchLocalidads() {
      fetch('http://localhost:8080/api/v1/localidads')
        .then(response => response.json())
        .then(data => {
          this.localidads = data;
        })
        .catch(error => {
          console.error('Error fetching localidads:', error);
        });
    },
    fetchEstadoCivils() {
      fetch('http://localhost:8080/api/v1/estadocivils')
        .then(response => response.json())
        .then(data => {
          this.estadoCivils = data;
        })
        .catch(error => {
          console.error('Error fetching estadoCivils:', error);
        });
    },
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchMedioComs() {
      fetch('http://localhost:8080/api/v1/mediocoms')
        .then(response => response.json())
        .then(data => {
          this.medioComs = data;
        })
        .catch(error => {
          console.error('Error fetching medioComs:', error);
        });
    },
  },
}
</script>
